import React from "react";

import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { IconButton } from "@mui/material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";

import DeleteIcon from "@mui/icons-material/Delete";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteModal from "./DeleteModal";
import EditModal from "./EditModal";
export default function MoreOptions({ row, setVendorsArray, type }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openDeleteModal, setOpenDeleteModal] = React.useState(false);
  const [openEditModal, setOpenEditModal] = React.useState(false);

  const openMenu = Boolean(anchorEl);

  const handleOpenDeleteModal = () => setOpenDeleteModal(true);
  const handleCloseDeleteModal = () => setOpenDeleteModal(false);

  const handleOpenEditModal = () => setOpenEditModal(true);
  const handleCloseEditModal = () => setOpenEditModal(false);

  const handleOpenMenu = (event) => setAnchorEl(event.currentTarget);
  const handleCloseMenu = () => setAnchorEl(null);

  const onDelete = () => {
    handleCloseMenu();
    handleOpenDeleteModal();
  };
  const onEdit = () => {
    handleCloseMenu();
    handleOpenEditModal();
  };

  return (
    <>
      <IconButton onClick={handleOpenMenu}>
        <MoreHorizIcon />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={openMenu}
        onClose={handleCloseMenu}
        onClick={handleCloseMenu}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem onClick={onEdit}>
          <ListItemIcon>
            <BorderColorIcon fontSize="small" color="success" />
          </ListItemIcon>
          Edit {type === "vendors" ? "Vendor" : "Client"}
        </MenuItem>
        <MenuItem onClick={onDelete}>
          <ListItemIcon>
            <DeleteIcon fontSize="small" color="error" />
          </ListItemIcon>
          Delete {type === "vendors" ? "Vendor" : "Client"}
        </MenuItem>
      </Menu>

      <EditModal
        row={row}
        openModal={openEditModal}
        handleCloseModal={handleCloseEditModal}
        setVendorsArray={setVendorsArray}
        type={type}
      />

      <DeleteModal
        row={row}
        openModal={openDeleteModal}
        handleCloseModal={handleCloseDeleteModal}
        setVendorsArray={setVendorsArray}
        type={type}
      />
    </>
  );
}
